// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".UserTaggingPingBodyStyles-cls1___ad9fed015844b9722e6{/*!*/}.UserTaggingPingBodyStyles-cls2___154613b1e8110683b15{font-size:24px;margin-right:8px;color:#b08920}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "UserTaggingPingBodyStyles-cls1___ad9fed015844b9722e6",
	"cls2": "UserTaggingPingBodyStyles-cls2___154613b1e8110683b15 UserTaggingPingBodyStyles-cls1___ad9fed015844b9722e6"
};
export default ___CSS_LOADER_EXPORT___;
